import { useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/config';
import { setMassCatalog } from '../utils/massCatalog';

// Holder massekatalogen i lageret oppdatert så lenge brukeren er innlogget (settings kan bare leses innlogget).
export function useMassCatalogSync(signedIn) {
  useEffect(() => {
    if (!signedIn) return undefined;
    return onSnapshot(
      doc(db, 'settings', 'massCatalog'),
      (snap) => setMassCatalog(snap.exists() ? snap.data() : null),
      () => setMassCatalog(null),
    );
  }, [signedIn]);
}
